<template>
<div>
  <div v-if="loading" id="loader"></div>
  <div v-else class="row">
    <div class="col-12 mt-0">
      <b-card no-body  class="mb-0" style="width: 470px !important;">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <p class="button1">4. Evidencia de cierre</p>
        </b-card-header>
        <b-card-body>
          <div class="row mt-3" v-if="this.user.core_role_id != 2 && stateRP !=true">
            <div class="col-3 text-right">
              <p class="p1"><b>Solicitar evidencia</b></p>
            </div>
            <div class="col-9 text-left">
              <select 
                v-model="bp"
                required
                class="custom-select mb-3"
                @change="sendRequest"
                >
                <option value="">--Seleccione Business Partner--</option>
                <option v-for="bp in bps.data" v-bind:key="bp.id" 
                  v-bind:value="bp.id">
                  {{ bp.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-3 text-right">
              <p class="p1"><b>Cargar evidencia</b></p>
            </div>
            <div class="col-5 text-left">
              <span v-if="evidencesL.length > 0" style="display:table; margin:0 auto;">
                <table class="table table-bordered table-striped table-hover table-sm">
                  <thead>
                    <tr class="p1">
                      <th>No.</th>
                      <th>Evidencia</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in evidencesL" :key="index"> 
                      <a :href="serverPath+'/'+row.path" target="_blank">
                        <th><p class="p1">{{index+1}}</p></th>
                        <th><p class="p1">{{row.name}}</p></th>
                      </a>
                      <th>
                        <div v-if="stateRP!=true">
                          <button 
                            type="button" 
                            class="btn btn-light"
                            v-on:click="deleteEvidence(row.id)"
                            >
                            <img src="@/assets/images/icons/trash.svg" />
                          </button>
                        </div>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </span>
            </div>
            <div class="col-4 text-left file-upload-img mt-5 mb-4">
              <div v-if="stateRP!=true">
                <input 
                  type="file"
                  id="fileDocu"
                  @change="fileSelected"
                  multiple
                />
                <div v-if="!loading" align='center'>
                  <span>
                    <img height="50px" width="120px" src="@/assets/images/settler/uploadFile3.jpg" />
                    <p class="p1 text-center">Arrastra el archivo o dar <b><u>click</u></b> para buscarlo</p>
                  </span>
                </div>
                <div v-else-if="loading" class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3" v-if="evidencesL.length > 0 && this.user.core_role_id !=2">
            <div class="col-3 text-right">
              <p class="p1"><b>Fecha de cierre</b></p>
            </div>
            <div class="col-9 text-left custom-control custom-switch" v-if="infoRPl.status != 'closed'">
              <b-form-datepicker
                v-model="fechaCierre" 
                class="mb-2"
                :date-format-options="{ year: 'numeric' , month: 'numeric', day: 'numeric' }"
                placeholder="AAAA-DD-MM"
                required
              >
              </b-form-datepicker>
            </div>
            <div class="col-9 text-left custom-control custom-switch" v-else>
              <p class="p1"><b>{{infoRPl.close_date}}</b></p>
            </div>
          </div>
          <div class="row mt-3" v-if="evidencesL.length > 0 && this.user.core_role_id!=2">
            <div class="col-3 text-right">
              <p class="p1"><b>Cerrar solicitud</b></p>
            </div>
            <div class="col-9 text-left custom-control custom-switch">
              <p class="p1">
                No
                <label class="switch">                                      
                  <input type="checkbox" 
                  v-model="stateRP"
                  v-on:change="closeRP"
                  >
                  <span class="slider round"></span>
                </label>
                Si
              </p>
            </div>
          </div>
        </b-card-body>
      </b-card>                          
    </div>
  </div>    
  <small v-show="error.flag" class="alert-danger">{{ error.message }}</small>
  <div>
    <b-modal 
      ref="my-modal" 
      hide-footer
      centered
      title="Atención al mensaje:"
      no-close-on-backdrop
      @hidden="hideModal">
      <div class="d-block text-center">
        <h3>{{this.msjModal}}</h3>
      </div>
      <b-button class="mt-3" variant="outline-danger"
        block 
        @click="hideModal">
          Cerrar
      </b-button>
    </b-modal>
  </div>
</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import serverConfig from "./../../services/config";


export default {
  name: "Close",
  components: {},  
  data() {
    return {
      serverPath: serverConfig.permisosURL,      
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      bp: '',
      stateRP: '',
      fechaCierre: '',

      msjModal: "",
      flagPath: false,
      nameFile: '',
      show: true,

      //filesSelected: [],
      evidencesL: [],
      
    };
  },
  beforeMount() {
    this.actGetInfoRP(this.$route.params.id).then(() =>{
      this.setInfoRPl(this.infoRP.data);
      this.stateRP = (this.infoRPl.status == 'closed') ? true : false;
    });
    this.actGetEvidencesRP(this.$route.params.id).then(() =>{
      this.evidencesL = [];
      this.evidences.data.forEach(row => {
        let nameFile = row.path.split('/');
        this.evidencesL.push({
          'id': row.id,
          'name': nameFile[2],
          'path': row.path
        })
      });
    });
    this.actGetBP();
   
  },
  computed: {
    ...mapState("modCore", ["user"]),    
    ...mapState("modRightPetition", [
      "infoRP",      
      "responsibles",
      "files",
      "evidences",
      "infoRPl",
      "stateProcess",
      "linkProccess",
      "loading",
    ]),
    ...mapState("modRequest",[
      "bps",
    ]),
  },
  methods:{
    ...mapActions("modRightPetition", [      
      "actGetfiles",
      "actGetEvidencesRP",
      "actSaveEvidenceRP",
      "actSendRequestBP",
      "actGetInfoRP",
      "actDeleteFileEvidence",
    ]),
    ...mapActions("modRequest", [
      "actGetBP",
    ]),
    ...mapMutations("modRightPetition", [
      "setStateProcess",
      "setInfoRPl",
      "setLinkProccess",
      ]),

    fileSelected() {
      var data = [];
      var formData = new FormData();
      const dato = document.querySelector('#fileDocu');
      formData.append("files[]", dato.files[0]);

      data[0] = this.$route.params.id;
      data[1] = formData;

      this.actSaveEvidenceRP(data).then(() =>{
        this.actGetEvidencesRP(this.$route.params.id).then(() =>{
          this.evidencesL = [];
          this.evidences.data.forEach(row => {
            let nameFile = row.path.split('/');
            this.evidencesL.push({
              'id': row.id,
              'name': nameFile[2],
              'path': row.path
            })
          });
        });
      });
    },

    sendRequest(){
      var data = [];
      data[0] = this.$route.params.id;
      data[1] = {
        "business_partner_id": this.bp
      }     

      this.actSendRequestBP(data).then(() =>{
        this.showModal("Se envio correctame la notificación de solicitud de evidencia",0);
      });

    },

    closeRP(){
      var data = [];

      data[0] = this.$route.params.id;
      var formData = new FormData();
      formData.append("close_request", (this.stateRP == true) ? 1 : 0);
      formData.append("close_date", this.fechaCierre);
      data[1] = formData;

      this.actSaveEvidenceRP(data).then(() =>{
        this.actGetInfoRP(this.$route.params.id).then(() =>{
          this.setInfoRPl(this.infoRP.data);
          if(this.stateRP == true){
            this.setStateProcess(4);
            this.setLinkProccess(4);
          }
          else{
            this.setStateProcess(3);
            this.setLinkProccess(3);
            //this.showModal("El Derecho de Peticion actualizó",0);
          }

        });
      });
    },

    deleteEvidence(id){
      this.$bvModal.msgBoxConfirm('¿Desea borrar este archivo del servidor?',
        {
          title: 'Atención al mensaje:',
          size: 'sm',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'CONTINUAR',
          cancelTitle: 'CANCELAR',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if(value == true){
            this.actDeleteFileEvidence(id).then(() =>{
              this.actGetEvidencesRP(this.$route.params.id).then(() =>{
                this.evidencesL = [];
                this.evidences.data.forEach(row => {
                  let nameFile = row.path.split('/');
                  this.evidencesL.push({
                    'id': row.id,
                    'name': nameFile[2]
                  })
                });
              });
            });
          }
        })
        .catch(err => {
          console.log(err);
        })
    },

    formatDateShow(date){
      var d = new Date(date);
      var datestring = d.getDate()+" "+this.monthNames[d.getMonth()+1] +" "+ d.getFullYear();
      return datestring;
    },
    
    showModal(msj,flag) {
        this.msjModal = msj;
        this.flagPath = flag;
        this.$refs['my-modal'].show()
      },
    hideModal() {
        this.$refs['my-modal'].hide()
        if(this.flagPath == 1){
          this.$router.push({ path: '/solicitudes' });
        }
     },
  }
};
</script>

<style lang="scss">
//@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.page-closeRP {
  .title-1 {
        font-size: 24px;
        font-weight: bold;
        color: #1C3A4E;
      }
  .cont-rightpetition-text {    
    .cont-title {
      color: #1c3a4e;
      .title-1 {
        font-size: 20px;
        font-weight: bold;
        color: #1c3a4e;
      }
      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }
    .form-rightpetition {
      .form-group-req {
        input[type="text"] {
          height: 32px;
          border: 1px solid #454545;
          border-radius: 4px;
          padding: 0 10px;
        }
      }     
            
    }
  }
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }
  .button1 {
    background: #E9ECEE;
    color: #1C3A4E;
    //border-radius: 50px;
    height: 25px;
    font-size: 16px;
    text-align: left !important;   
    padding-left: 5%;
    padding-right: 5%;
    
  }       
  .button2 {
    background: #1C3A4E;
    color: #ffffff;
    border-radius: 50px;
    height: 32px;
    font-size: 16px;
    text-align: left !important;   
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#cddce6, 5);
    }
  }
  .button3 {
    border: none;
    background-color: inherit;
    padding: 5px 10px;
    font-size: 11px;
    cursor: pointer;
    display: inline-block;
    text-decoration: underline;
  }
  .button4 {
    background: #99A6AF;
    color: #ffffff;
    border-radius: 8px;
    height: 32px;
    font-size: 16px;
    text-align: left !important;   
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#99A6AF, 5);
    }
  }
  .button2:hover {background: #eee;}
  .default {color: black;}   
  .tr1{
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #454545;
    padding-left: 5%;
  }   
  .td1 {
    background: #1C3A4E;
    color: #ffffff;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 19px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
  }
  .td2 {
    background: #ffffff;
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 19px;
    width: 95px;
    text-align: center;
  }
  .td3 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 25px;
    text-align: center;
  }
  .td4 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 10px;
    line-height: 12px;
    text-align: center;    
  }
  .td5 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 12px;
  }  
  .tabla1{  
    border-radius: 5px;
    border: 3px solid #1C3A4E;
    border-color: #1C3A4E;  
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 470px
  }
  .p1 {
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 19px;    
  }
  .collapsed > .when-opened,
      :not(.collapsed) > .when-closed {
          display: none;
      }
  .img1 {
    width: 18px;
    height: 18px;    
    left: 100%;
    top: 100%;     
    float: center;    
  }
  .centerImg1 {
    width: 16px;
    height: 16px;    
    top: 100%;    
    float: right;    
  }
  .mycheck 
  { 
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: #779B49;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #779B49;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
  .custom-file-upload {
      border: 1px solid #ccc;
      display: inline-block;
      padding: 1px 2px;
      cursor: pointer;
  }
  input[type="file"] {
    display: none;
  }
  .scrollable {
    overflow: hidden;
    overflow-y: scroll;
    height: calc(30vh - 20px);
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
}
</style>